import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Slider } from '@xingternal/slider';

import { SliderMarkLabel } from '@/components/slider-mark-label';
import { MAX_SALARY, MIN_SALARY, STEP_SALARY } from '@/domain/search/constants';

import * as S from './filters.styles';

type SalaryFilterProps = {
  salaryValues?: [number, number];
  onFilterChanged?: (values: number[] | undefined) => void;
};

export const SalaryFilter: React.VFC<SalaryFilterProps> = ({ salaryValues, onFilterChanged }) => {
  const [sliderValues, setSliderValues] = useState(salaryValues ?? [MIN_SALARY, MAX_SALARY]);

  const handleOnSliderChange = (_: Event, values: number[]): void => {
    setSliderValues(values);
  };

  const handleOnSliderCommitChanges = (_: Event, values: number[]): void => {
    setSliderValues(values);
    onFilterChanged?.(values[0] === MIN_SALARY && values[1] === MAX_SALARY ? undefined : values);
  };

  useEffect(() => {
    if (!salaryValues) {
      setSliderValues([MIN_SALARY, MAX_SALARY]);
    }
  }, [salaryValues]);

  return (
    <S.FiltersContainer>
      <S.InlineFilter>
        <S.FilterHeadline>
          <FormattedMessage id="SE_FILTER_JOBS_SALARY_LABEL" />
        </S.FilterHeadline>
      </S.InlineFilter>
      <S.SliderWrapper>
        <Slider
          min={MIN_SALARY}
          max={MAX_SALARY}
          step={STEP_SALARY}
          value={sliderValues}
          onChange={handleOnSliderChange}
          onChangeCommitted={handleOnSliderCommitChanges}
        />
        <SliderMarkLabel value={sliderValues[0]} />
        <SliderMarkLabel value={sliderValues[1]} />
      </S.SliderWrapper>

      <S.FilterDivider />
    </S.FiltersContainer>
  );
};
